import { render, staticRenderFns } from "./addCourseDialog.vue?vue&type=template&id=5d9f92da&scoped=true&"
import script from "./addCourseDialog.vue?vue&type=script&lang=js&"
export * from "./addCourseDialog.vue?vue&type=script&lang=js&"
import style0 from "./addCourseDialog.vue?vue&type=style&index=0&id=5d9f92da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9f92da",
  null
  
)

export default component.exports